import { createSlice } from "@reduxjs/toolkit";


const initState={
    promptTestingResponce:{},
    propmtSaveData:{},
    savePromptData:{},
    proptTestingLoading:false

}

const promptTestingReducer=createSlice({
    name:"promptTesting",
    initialState:initState,
    reducers:{
        promptTestingResponceFun:(state,action)=>{
            state.promptTestingResponce=action?.payload
        },
        propmtSaveDataFun:(state,action)=>{
            state.propmtSaveData=action?.payload
        },
        savePromptDataFun:(state,action)=>{
            state.savePromptData=action?.payload
        },
        proptTestingLoadingFun:(state,action)=>{
            state.proptTestingLoading=action?.payload
        }
        
    }
})

export const {proptTestingLoadingFun,savePromptDataFun,promptTestingResponceFun,propmtSaveDataFun}=promptTestingReducer.actions
export default promptTestingReducer.reducer